import { useLocation, useNavigate } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import {
  MOBILE_BOTTOM_NAV_HEIGHT_PX,
  SAFE_AREA_LEFT,
  SAFE_AREA_RIGHT,
} from './layout.constants';
import { matchesNavPath, primaryNavItems } from './primaryNavItems';

function selectedIndexForPath(pathname: string): number {
  return primaryNavItems.findIndex((item) => matchesNavPath(item.path, pathname));
}

/**
 * Persistent bottom navigation for smartphone-class layouts (FR-003, FR-006).
 */
export default function MobileBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const idx = selectedIndexForPath(location.pathname);

  return (
    <Paper
      square
      elevation={8}
      component="nav"
      aria-label="Primary"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.appBar,
        pl: SAFE_AREA_LEFT,
        pr: SAFE_AREA_RIGHT,
        pb: 'env(safe-area-inset-bottom, 0px)',
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <BottomNavigation
        value={idx >= 0 ? idx : false}
        onChange={(_, newValue) => {
          const item = primaryNavItems[newValue as number];
          if (item) navigate(item.path);
        }}
        showLabels
        sx={{
          height: MOBILE_BOTTOM_NAV_HEIGHT_PX,
          maxWidth: '100%',
          '& .MuiBottomNavigationAction-root': {
            minWidth: 0,
            flex: 1,
            maxWidth: '20%',
            minHeight: 48,
            py: 0.5,
            px: 0.25,
          },
        }}
      >
        {primaryNavItems.map((item) => {
          const Icon = item.icon;
          return (
            <BottomNavigationAction
              key={item.path}
              label={item.text}
              icon={<Icon fontSize="small" />}
              sx={{
                '& .MuiBottomNavigationAction-label': {
                  fontSize: '0.7rem',
                },
              }}
            />
          );
        })}
      </BottomNavigation>
    </Paper>
  );
}
